/**
 * @typedef {Object} MeloApp
 * @property {string} slug
 * @property {string} title
 * @property {string} subtitle
 * @property {string} description
 * @property {string} shortDescription
 * @property {string} iconLetter
 * @property {string} [iconImage]
 * @property {string[]} gallery
 * @property {string} category
 * @property {string} tag
 * @property {string} views
 * @property {string} searchKeywords
 * @property {string} searchImage
 * @property {string} searchExcerpt
 * @property {boolean} [showInHomeList]
 * @property {boolean} [showInSearch]
 * @property {boolean} [showInRelated]
 * @property {number} [homeListOrder]
 */

(function (global) {
    'use strict';

    /**
     * Repository contract for mini apps data.
     * Implementations: MockMeloAppsRepository, HttpMeloAppsRepository (future).
     *
     * @interface MeloAppsRepository
     * @function getAll
     * @function getBySlug
     */

    global.MeloApps = global.MeloApps || {};
})(typeof window !== 'undefined' ? window : global);
